import React, { useContext } from "react";
import Frame from "../../../../components/DiscResult/Frame";
import { UserData } from "../../../../contexts/UserInfoContext";
import { Link } from "react-router-dom";
import Page from "../Page";

const HighD = ({ testResult }) => {
  const { user, userLoaded } = useContext(UserData);

  return (
    <>
      <div
        style={{ breakAfter: "page" }}
        className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
      >
        {/* frame */}
        <Frame page={11} user={testResult?.app ? testResult.app : user} />

        <div className="w-full flex flex-col gap-4 p-10 pt-28">
          <h2 className="text-3xl text-gray-800 font-black self-center my-3">
            معرفی الگوی رفتاری
          </h2>

          {user?.tests?.filter((test) => test.test === "disc").length === 0 ? (
            <div className="flex flex-col items-center mt-48 gap-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-14 h-14 fill-red-500"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span className="text-red-500 text-xl font-bold">
                برای مشاهده ادامه جواب ها لطفا تست دیسک را خریداری کنید
              </span>
              <Link
                to={"/shop"}
                target="_blank"
                className="text-yellow-700 flex items-center gap-1"
              >
                <span>برو به فروشگاه</span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 stroke-yellow-700"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                  />
                </svg>
              </Link>
            </div>
          ) : (
            <p className="text-gray-800 leading-7">
              افراد دارای الگوی رفتاری High D ، شخصیت‌هایی قوی، مستقل و
              نتیجه‌گرا دارند. این افراد به سرعت تصمیم می‌گیرند، ریسک‌پذیر هستند
              و معمولاً در موقعیت‌های رقابتی و چالش‌برانگیز می‌درخشند. هدف اصلی
              آن‌ها دستیابی به نتایج و باز کردن مسیرهای جدید برای موفقیت است.
              ویژگی کلیدی High D ها این است که علاقه زیادی به کنترل شرایط و
              هدایت دیگران دارند. آن‌ها معمولاً راه‌حل‌ها را خودشان پیدا می‌کنند
              و دوست ندارند منتظر دیگران بمانند یا به روش‌های معمول و سنتی محدود
              شوند. اگر ببینند راهی وجود ندارد، راهی می‌سازند!
            </p>
          )}
        </div>
      </div>

      <div
        style={{ breakAfter: "page" }}
        className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
      >
        {/* frame */}
        <Frame page={11} user={testResult?.app ? testResult.app : user} />

        <div className="w-full flex flex-col gap-4 p-10 pt-28">
          <h2 className="text-3xl text-gray-800 font-black self-center my-3">
            High D ها در محیط کاری یا اجتماعی
          </h2>

          {user?.tests?.filter((test) => test.test === "disc").length === 0 ? (
            <div className="flex flex-col items-center mt-48 gap-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-14 h-14 fill-red-500"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span className="text-red-500 text-xl font-bold">
                برای مشاهده ادامه جواب ها لطفا تست دیسک را خریداری کنید
              </span>
              <Link
                to={"/shop"}
                target="_blank"
                className="text-yellow-700 flex items-center gap-1"
              >
                <span>برو به فروشگاه</span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 stroke-yellow-700"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                  />
                </svg>
              </Link>
            </div>
          ) : (
            <p className="text-gray-800 leading-7">
              سریع عمل می‌کنند و انتظار دارند دیگران هم همین‌طور باشند. از
              رویارویی با مشکلات فرار نمی‌کنند، بلکه دنبال راه‌حل‌های خلاقانه
              می‌گردند. اگر حس کنند قدرت یا استقلالشان تهدید می‌شود، ممکن است
              پرخاشگر شوند یا به دیگران سخت بگیرند. نقاط قوت مهم این افراد شامل
              اراده قوی، اعتماد به نفس بالا، روحیه رقابتی، و انگیزه برای پیشرفت
              است. اما اگر این ویژگی‌ها تعدیل نشوند، ممکن است باعث کنترل‌گری بیش
              از حد، نادیده گرفتن احساسات دیگران، و عجله در تصمیم‌گیری شوند.
            </p>
          )}
        </div>
      </div>

      <div
        style={{ breakAfter: "page" }}
        className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
      >
        {/* frame */}
        <Frame page={11} user={testResult?.app ? testResult.app : user} />

        <div className="w-full flex flex-col gap-4 p-10 pt-28">
          <h2 className="text-3xl text-gray-800 font-black self-center my-3">
            ابعاد و توصیف ویژگیهای رفتاری در الگوی High D
          </h2>

          {user?.tests?.filter((test) => test.test === "disc").length === 0 ? (
            <div className="flex flex-col items-center mt-48 gap-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-14 h-14 fill-red-500"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span className="text-red-500 text-xl font-bold">
                برای مشاهده ادامه جواب ها لطفا تست دیسک را خریداری کنید
              </span>
              <Link
                to={"/shop"}
                target="_blank"
                className="text-yellow-700 flex items-center gap-1"
              >
                <span>برو به فروشگاه</span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 stroke-yellow-700"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                  />
                </svg>
              </Link>
            </div>
          ) : (
            <div className="flex flex-col gap-4">
              <p className="text-gray-800 leading-7">
                1. ویژگی کلیدی: تسلط و کنترل افراد High D تمایل دارند روی محیط و
                اطرافیان کنترل داشته باشند و سریع به سمت نتیجه حرکت کنند؛ بدون
                اینکه زیاد نگران مخالفت دیگران باشند. آن‌ها معمولاً برای رسیدن
                به هدف، سرعت عمل و قدرت تصمیم‌گیری بالایی دارند و از
                مسئولیت‌پذیری نمی‌ترسند.
              </p>

              <p className="text-gray-800 leading-7">
                مثال کاربردی: فرض کنید مدیر یک تیم فروش هستید و می‌خواهید تا
                پایان هفته فروش را ۲۰٪ افزایش دهید. احتمال زیاد به جای مشورت
                طولانی با تیم، خیلی سریع هدف را مشخص می‌کنید، نقش‌ها را تقسیم
                کرده و همه را به سمت نتیجه هل می‌دهید.
              </p>

              <p className="text-gray-800 leading-7">
                2. انگیزه‌ها و اهداف High D ها عاشق پیشرفت، رقابت، استقلال، و
                کسب نتیجه هستند. چالش و سختی آن‌ها را جذب می‌کند، نه فراری.
              </p>

              <p className="text-gray-800 leading-7">
                نمونه فیلم پیشنهادی: در فیلم در جستجوی خوشبختی، ویل اسمیت در نقش
                اصلی بدون ترس از رد شدن‌ها و چالش‌ها به سمت هدفش می‌تازد –
                نمونه‌ای از رفتارهای High D .
              </p>

              <p className="text-gray-800 leading-7">
                3. سبک کار و تصمیم‌گیری این افراد در شرایط فشار، کار را خودشان
                انجام می‌دهند و ترجیح می‌دهند سریع تصمیم بگیرند تا اینکه منتظر
                نظر جمعی بمانند. گاهی این عجله باعث بی‌توجهی به جزئیات و خطرات
                می‌شود. پیشنهاد بهبود: داشتن یک فرد دقیق و جزئی‌نگر کنارشان
                مثلاً High C می‌تواند تصمیم‌هایشان را متعادل کند.
              </p>

              <p className="text-gray-800 leading-7">
                4. تعامل با دیگران از کنترل شدن خوششان نمی‌آید ولی خودشان علاقه
                دارند دیگران را هدایت یا حتی کنترل کنند. در مقابل محدودیت‌ها
                گاهی پرخاشگر می‌شوند و انتظارات بالایی از اطرافیان دارند. مثال
                ملموس: کارمند High D ممکن است در جلسه‌ای که با روال کند پیش
                می‌رود، ناگهان وسط حرف دیگران بپرد و بگوید: «بریم سر اصل مطلب!»
              </p>

              <p className="text-gray-800 leading-7">
                5. نقاط قابل بهبود و چالش‌ها عجول بودن و کم‌تحملی بی‌توجهی به
                احساسات دیگران خشم زودهنگام غفلت از استراحت و خودمراقبتی عدم
                بررسی ریسک‌ها
              </p>

              <p className="text-gray-800 leading-7">
                6. توصیه‌های تعدیل و تقویت: تمرین گوش دادن فعال و پرسیدن
                سؤال‌های عمیق مشورت با افراد تحلیل‌گر قبل از تصمیم‌گیری مهم
                ایجاد زمان‌های استراحت در برنامه کاری یادگیری صبوری و همدلی در
                برخورد با دیگران
              </p>
            </div>
          )}
        </div>
      </div>

      <div
        style={{ breakAfter: "page" }}
        className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
      >
        {/* frame */}
        <Frame page={11} user={testResult?.app ? testResult.app : user} />

        <div className="w-full flex flex-col gap-4 p-10 pt-28">
          <h2 className="text-3xl text-gray-800 font-black self-center my-3">
            انگیزه الگوی رفتاری High D
          </h2>

          {user?.tests?.filter((test) => test.test === "disc").length === 0 ? (
            <div className="flex flex-col items-center mt-48 gap-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-14 h-14 fill-red-500"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span className="text-red-500 text-xl font-bold">
                برای مشاهده ادامه جواب ها لطفا تست دیسک را خریداری کنید
              </span>
              <Link
                to={"/shop"}
                target="_blank"
                className="text-yellow-700 flex items-center gap-1"
              >
                <span>برو به فروشگاه</span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 stroke-yellow-700"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                  />
                </svg>
              </Link>
            </div>
          ) : (
            <div className="w-full flex flex-col gap-4">
              <p className="text-gray-800 leading-7">
                شما فردی هستید با تمایل بالا به تفکر سریع، تصمیم‌گیری قاطع و
                نشان دادن اعتمادبه‌نفس. این ویژگی‌ها برایتان نشانه قدرت و تسلط
                است. در نگاه دیگران، شخصیتی نافذ، صریح و قدرتمند دارید که
                معمولاً مسئولیت‌پذیر، مصمم و در موقعیت‌های چالشی پیش‌قدم هستید.
              </p>

              <p className="text-gray-800 leading-7">
                به‌دنبال مشاغلی می‌گردید که قدرت، پیچیدگی و رقابت بالایی دارند و
                می‌توانید در آن‌ها خود را به‌عنوان فردی موثر، مستقل و برتر نشان
                دهید. وقتی شرایط بر وفق مرادتان نیست، تمایل دارید احساسات واقعی
                خود از جمله خشم یا تندی را آشکار کنید و در دفاع از منافع خود،
                سخت‌گیر و قاطع عمل می‌کنید. استقلال‌طلبی، جاه‌طلبی و سرعت در
                تصمیم‌گیری ممکن است باعث شود دیگران شما را بی‌ملاحظه، خودمحور یا
                کم‌توجه به روابط انسانی تلقی کنند.
              </p>
            </div>
          )}
        </div>
      </div>

      <div
        style={{ breakAfter: "page" }}
        className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
      >
        {/* frame */}
        <Frame page={11} user={testResult?.app ? testResult.app : user} />

        <div className="w-full flex flex-col gap-4 p-10 pt-28">
          <h2 className="text-3xl text-gray-800 font-black self-center my-3">
            عادت های کاری الگوی رفتاری High D
          </h2>

          {user?.tests?.filter((test) => test.test === "disc").length === 0 ? (
            <div className="flex flex-col items-center mt-48 gap-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-14 h-14 fill-red-500"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span className="text-red-500 text-xl font-bold">
                برای مشاهده ادامه جواب ها لطفا تست دیسک را خریداری کنید
              </span>
              <Link
                to={"/shop"}
                target="_blank"
                className="text-yellow-700 flex items-center gap-1"
              >
                <span>برو به فروشگاه</span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 stroke-yellow-700"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                  />
                </svg>
              </Link>
            </div>
          ) : (
            <div className="w-full flex flex-col gap-4">
              <p className="text-gray-800 leading-7">
                در پی محک زدن توانایی‌ها و سنجش عملکرد خود از طریق کارهای چالشی،
                منحصر به‌فرد و پیچیده هستید. پروژه‌هایی که نیازمند تفکر
                استراتژیک، خلاقیت و پیروزی بر چالش‌ها باشند، برای شما جذاب‌اند.
                با توجه به انرژی بالا، فعالیت‌های کند یا جزئیات وقت‌گیر معمولاً
                شما را خسته یا عصبانی می‌کند. به‌دنبال نتیجه و پیروزی هستید و
                برای رسیدن به آن، از دیگران نیز توقع تلاش بالا دارید؛ حتی اگر
                این فشار باعث نارضایتی آنان شود.
              </p>
              <p className="text-gray-800 leading-7">
                در توسعه کسب‌وکار، تمرکز شما بر سودآوری و دستاوردهای ملموس است و
                در این حوزه معمولاً عملکردی چشمگیر دارید. تمایل به کنترل و هدایت
                امور دارید. زمانی در کار تیمی راحت هستید که نقش رهبری داشته
                باشید یا ابتکار عمل در دستتان باشد. در پروژه‌های دشوار و
                «غیرممکن» برای دیگران، داوطلب اول هستید و از اثبات توانمندی خود
                لذت می‌برید. نوع تاثیرگذاری‌تان بر دیگران از طریق صلابت، سرعت و
                نتیجه‌گرایی است. در برابر افراد کند یا بی‌انگیزه، معمولاً ناآرام
                یا پرخاشگر می‌شوید، اما عملکرد قوی و پرانرژی دیگران را تحسین
                می‌کنید.
              </p>
            </div>
          )}
        </div>
      </div>

      <div
        style={{ breakAfter: "page" }}
        className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
      >
        {/* frame */}
        <Frame page={11} user={testResult?.app ? testResult.app : user} />

        <div className="w-full flex flex-col gap-4 p-10 pt-28">
          <h2 className="text-3xl text-gray-800 font-black self-center my-3">
            دیدگاه های الگوی رفتاری High D
          </h2>

          {user?.tests?.filter((test) => test.test === "disc").length === 0 ? (
            <div className="flex flex-col items-center mt-48 gap-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-14 h-14 fill-red-500"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span className="text-red-500 text-xl font-bold">
                برای مشاهده ادامه جواب ها لطفا تست دیسک را خریداری کنید
              </span>
              <Link
                to={"/shop"}
                target="_blank"
                className="text-yellow-700 flex items-center gap-1"
              >
                <span>برو به فروشگاه</span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 stroke-yellow-700"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                  />
                </svg>
              </Link>
            </div>
          ) : (
            <div className="w-full flex flex-col gap-4">
              <p className="text-gray-800 leading-7">
                روحیه رقابتی بالا و میل به کنترل ممکن است منجر به چالش با دیگران
                شود. پیشنهاد می‌شود از رویکرد برد-برد در تعاملات استفاده کنید.
                رک‌گویی افراطی و استقلال بیش از حد می‌تواند توانمندی شما در کار
                تیمی را کاهش دهد و تصویری از شما به‌عنوان فردی خودمحور بسازد.
              </p>
              <p className="text-gray-800 leading-7">
                در شنیدن نظرات متفاوت صبور باشید، دیدگاه‌های مخالف را با آرامش
                بشنوید و دلایل تصمیمات‌تان را شفاف با دیگران در میان بگذارید.
                پیش از قبول مسئولیت‌های جدید، تأمل کنید تا خود و دیگران را در
                معرض فشارهای بی‌مورد قرار ندهید. با شناخت بهتر از محدودیت‌های
                رفتاری خود، می‌توانید به خلق ارزش و ثروت برای سازمان و
                اطرافیان‌تان کمک کنید.
              </p>
            </div>
          )}
        </div>
      </div>

      <Page testResult={testResult} title="اوقات فراغت  الگوی رفتاری High D">
        <p className="text-gray-800 leading-7">
          شما در زمان‌های فراغت و سفرهای خود تمایل دارید که همچنان استقلال و
          حریم خصوصی‌تان حفظ شود. فعالیت‌های مخاطره‌آمیز و خاص برای شما جذابیت
          دارند. این فعالیت‌ها ممکن است شامل عکاسی در مناطق منحصر به فرد،
          کوهنوردی در قله‌های صعب‌العبور، شکار، پرش با چتر، پرش با طناب،
          موج‌سواری و قایقرانی باشد. برای شما مهم است که تفریحاتتان در مکان‌هایی
          خاص و لوکس برگزار شوند که حاکی از سطح بالای توانایی‌ها و موفقیت‌های
          شخصی شما است.
        </p>
        <p className="text-gray-800 leading-7">
          برای مثال، ممکن است شما سفر به یک منطقه کوهستانی را انتخاب کنید تا در
          آنجا کوهنوردی کرده و از بلندترین قله‌های جهان صعود کنید. یا شاید به
          جای یک تعطیلات معمولی به سفرهایی خاص بروید که در آن علاوه بر لذت از
          تفریحات هیجان‌انگیز، با افرادی با سطح اجتماعی بالا و فرصت‌های کاری
          جدید آشنا شوید. حتی در این نوع سفرها نیز شما تمایل دارید تا با افراد
          موفق و تاثیرگذار ملاقات کنید.
        </p>
        <p className="text-gray-800 leading-7">
          از طرفی، شما اوقات فراغت خود را می‌توانید با فعالیت‌هایی در راستای
          توسعه روابط کاری و کسب و کار نیز پر کنید. به طور مثال، ممکن است در یک
          رویداد یا کنفرانس شرکت کنید که ترکیبی از بازی‌های رقابتی، کارگاه‌های
          آموزشی و فرصت‌های شبکه‌سازی باشد. در این محیط‌ها شما از برقراری
          ارتباطات حرفه‌ای و ایجاد فرصت‌های جدید برای پیشرفت شغلی لذت می‌برید.
        </p>
        <p className="text-gray-800 leading-7">
          همچنین، علاقه شما به بازی‌ها و تفریحات رقابتی که نیازمند استراتژی و
          برنامه‌ریزی است نیز در اوقات فراغت‌تان مشهود است. شما دوست دارید در
          این فعالیت‌ها همیشه در موقعیت برنده قرار بگیرید. برای مثال، ممکن است
          در یک بازی کارتی یا ورزشی شرکت کنید که در آن نیاز به تفکر استراتژیک،
          ریسک‌پذیری و تصمیم‌گیری سریع دارید. این ویژگی رقابتی و تمایل به برنده
          شدن در اکثر جنبه‌های زندگی شما، حتی در تفریحات، قابل مشاهده است.
        </p>
      </Page>

      <Page testResult={testResult} title="تصمیم گیری">
        <p className="text-gray-800 leading-7">
          برای اخذ تصمیمات، پیشنهاد می‌شود که به جای عجله در تصمیم‌گیری‌ها،
          بررسی‌های عمیق‌تری انجام دهید و ریسک‌های مختلف را در نظر بگیرید.
          اعتماد به نفس بالای شما، اگرچه یک نقطه قوت است، می‌تواند باعث شود که
          گاهی اوقات شتابزده عمل کنید و این موضوع ممکن است در مواردی پیامدهایی
          ناخوشایند برای شما به همراه داشته باشد. برای مثال، ممکن است در یک
          مذاکره کاری، به دلیل سرعت در تصمیم‌گیری، فرصت‌های مهمی را از دست دهید
          که نیاز به مشورت و بررسی دقیق‌تر داشتند.
        </p>
        <p className="text-gray-800 leading-7">
          برای جلوگیری از این موضوع، توصیه می‌شود قبل از هر اقدامی با افراد
          درون‌گرا و منطقی مانند افرادی با الگوهای رفتاری CS و High C که دارای
          هوش هیجانی بالا هستند، مشورت کنید. این افراد می‌توانند به شما کمک کنند
          تا از دیدگاه‌های مختلف به موضوع نگاه کنید و تصمیم بهتری بگیرید.
          همچنین، به دلیل تمایل به بروز عصبانیت در مواقعی که با مشکلات روبه‌رو
          می‌شوید، هنگام عصبانیت از اتخاذ تصمیمات خودداری کنید، زیرا ممکن است
          تصمیمات احساسی و اشتباه بگیرید.
        </p>
      </Page>

      <Page testResult={testResult} title="پیشنهادات جهت بهبود عملکرد شما">
        <p className="text-gray-800 leading-7">
          شما فردی با اعتماد به نفس بالایی هستید که این ویژگی می‌تواند به شما در
          بسیاری از موقعیت‌ها کمک کند. با این حال، اگر بخواهید همه کارها را به
          تنهایی انجام دهید و با دیگران همکاری نکنید، ممکن است این رفتار شما را
          خودراضی و خودخواه نشان دهد. برای مثال، ممکن است در یک پروژه تیمی، به
          دلیل اینکه تمایل دارید همه کارها را به تنهایی انجام دهید، همکارانتان
          احساس کنند که نظر و کمک آن‌ها برای شما اهمیتی ندارد. برای اینکه
          بتوانید احترام دیگران را جلب کنید، لازم است به روش‌های درست انجام
          کارها در منزل و محل کار توجه کنید و از رفتارهای خودمحورانه اجتناب
          کنید.
        </p>
        <p className="text-gray-800 leading-7">
          حتما مراقب باشید که با رک‌گویی بیش از حد خود، دیگران را ناراحت نکنید.
          به یاد داشته باشید که افراد ممکن است از صحبت‌های تند شما احساس ناامنی
          یا ناراحتی کنند. سعی کنید در رفتار خود به دیگران توجه نشان دهید و
          احساسات خود را به طور مثبت و با سخاوت ابراز کنید. برای مثال، به جای
          بیان نظرات تند، می‌توانید به دیگران با دقت گوش دهید و در موقعیت‌های
          حساس، نظرات خود را با احترام و دقت بیشتری مطرح کنید.
        </p>
        <p className="text-gray-800 leading-7">
          برای اینکه کارهای خود را به درستی انجام دهید، به برنامه‌ریزی مناسب
          نیاز دارید. تنها به سرعت انجام کارها بسنده نکنید، بلکه باید به جزئیات
          و کیفیت کار نیز توجه کنید. اگر در یک پروژه کاری یا تصمیم‌گیری به دقت
          برنامه‌ریزی نکنید، ممکن است در پایان با نتایج نامطلوب روبه‌رو شوید.
          برای مثال، ممکن است در یک پروژه مهم با زمان محدود، تنها به سرعت انجام
          کار توجه کنید و از کیفیت آن غافل شوید که ممکن است در بلندمدت تاثیرات
          منفی داشته باشد.
        </p>
        <p className="text-gray-800 leading-7">
          توصیه می‌شود که هنگام انجام کارهای خود، از نقاط قوت خود مانند
          واقع‌گرایی، هوش و ذکاوت، ماجراجویی و توانایی ابتکار عمل استفاده کنید.
          همچنین، برای کاهش اشتباهات، بهتر است تکالیف خود را حداقل دو بار چک
          کنید تا از دقت و صحت انجام آن‌ها اطمینان حاصل کنید. در سفرها و اوقات
          فراغت، سعی کنید از عجله در رسیدن به مقصد خودداری کنید و به لذت بردن از
          مسیر سفر توجه داشته باشید. این می‌تواند به شما کمک کند تا علاوه بر
          رسیدن به مقصد، تجربه‌ای آرام و بدون استرس داشته باشید.
        </p>
        <p className="text-gray-800 leading-7">
          در تصمیم‌گیری‌های خود، صبورتر باشید و جزئیات را با دقت بیشتری بررسی
          کنید. به ویژه زمانی که با مسائل پیچیده روبه‌رو هستید، به نظر افراد
          دقیق و جزئی‌نگر که دیدگاه‌های متضاد دارند، توجه بیشتری داشته باشید.
          این می‌تواند به شما کمک کند تا تصمیمات بهتری اتخاذ کنید و از اشتباهات
          احتمالی جلوگیری کنید.
        </p>
      </Page>

      <Page testResult={testResult} title="پیشنهادات اجتماعی و رفتاری">
        <p className="text-gray-800 leading-7">
          در روابط اجتماعی و خانوادگی، حتما به عزیزان و خانواده خود بگویید که
          چقدر آن‌ها را دوست دارید. این کار باعث تقویت روابط عاطفی شما می‌شود و
          نشان می‌دهد که به احساسات دیگران اهمیت می‌دهید. همچنین، در محیط‌های
          کاری، از تعریف و تمجید کردن از دیگران غافل نشوید. این رفتار باعث ایجاد
          یک محیط مثبت و حمایتگر می‌شود که برای همکاری‌های موفق ضروری است.
        </p>
        <p className="text-gray-800 leading-7">
          در انجام کارهای گروهی، سعی کنید فقط به دنبال انجام نظرات خود نباشید.
          به دیگران اجازه دهید که نظرات خود را مطرح کنند و از تفاوت‌های آن‌ها
          برای رسیدن به بهترین نتیجه استفاده کنید. برای مثال، در یک تیم کاری، به
          جای تحمیل نظرات خود، از ایده‌های همکاران خود بهره‌برداری کنید و
          تصمیمات گروهی را با همکاری تیم اتخاذ کنید.
        </p>
        <p className="text-gray-800 leading-7">
          همچنین، به تفاوت‌های دیگران اهمیت بدهید و از نظرات آن‌ها در
          تصمیم‌گیری‌های خود کمک بگیرید. به یاد داشته باشید که هیجان، تنوع و
          سرعت برای همه جذاب نیست، بنابراین در مواقعی که احساس می‌کنید نیاز به
          آرامش و پیش‌بینی دارید، انعطاف‌پذیر و ثابت باشید.
        </p>
      </Page>

      <Page testResult={testResult} title="توصیه‌های کلیدی">
        <p className="text-gray-800 leading-7">
          به اینکه رفتار و صحبت‌های شما چه تاثیری بر دیگران می‌گذارد، توجه کنید.
          در مواقع حساس و پر استرس، شتابزده عمل نکنید و کارها را با دقت بیشتری
          بررسی کنید. خودمحوری را کنار بگذارید و در موقعیت‌های اجتماعی و کاری،
          اجتماعی‌تر و منعطف‌تر باشید.
        </p>
      </Page>

      <Page testResult={testResult} title="رمز موفقيت">
        <p className="text-gray-800 leading-7">
          موفقیت در بسیاری از جنبه‌های زندگی به رفتارها و عادات خاصی بستگی دارد
          که می‌تواند شما را در مسیر رشد و پیشرفت قرار دهد. برخی از این رفتارها
          عبارتند از:
        </p>

        <p className="text-gray-800 leading-7">
          <strong>1. خوب گوش کردن :</strong> یکی از کلیدهای موفقیت در روابط کاری
          و شخصی، توانایی خوب گوش دادن است. وقتی به دیگران گوش می‌دهید، نشان
          می‌دهید که به آن‌ها اهمیت می‌دهید و نظراتشان برایتان ارزشمند است. این
          مهارت باعث می‌شود تا ارتباطات شما تقویت شود و بتوانید نیازهای واقعی
          دیگران را درک کنید. برای مثال، در یک جلسه کاری، گوش دادن دقیق به نظرات
          همکاران می‌تواند به شما کمک کند تا تصمیمات بهتری بگیرید و مشکلات
          احتمالی را شناسایی کنید.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>2. کاهش تحریک‌پذیری :</strong> تحریک‌پذیری بالا می‌تواند در
          موقعیت‌های مختلف مشکلاتی ایجاد کند. شما می‌توانید با تمرین آرامش و
          صبر، واکنش‌های خود را کنترل کنید. این امر به ویژه در شرایط استرس‌زا و
          هنگام مواجهه با چالش‌های کاری ضروری است. به عنوان مثال، وقتی که با
          مخالفت شدید در محل کار روبه‌رو می‌شوید، واکنش‌های هیجانی می‌تواند
          تاثیر منفی بر نتیجه بگذارد. سعی کنید در این مواقع، به جای واکنش فوری،
          کمی زمان برای تفکر و سپس پاسخ‌دهی بگذارید.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>3. تمرکز بیشتر :</strong> تمرکز یکی از مهارت‌های کلیدی در
          موفقیت است. وقتی بر روی یک وظیفه یا هدف خاص تمرکز می‌کنید، احتمال
          موفقیت شما به طرز قابل توجهی افزایش می‌یابد. برای مثال، اگر در حال
          انجام پروژه‌ای مهم هستید، بهتر است از حواس‌پرتی‌های غیر ضروری دوری
          کنید تا بتوانید عملکرد بهتری داشته باشید. برنامه‌ریزی و تقسیم وقت به
          بخش‌های مشخص می‌تواند در افزایش تمرکز موثر باشد.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>4. توجه به احساسات دیگران :</strong> توانایی درک و توجه به
          احساسات دیگران یکی از ویژگی‌های بارز افراد موفق است. این توانایی به
          شما کمک می‌کند تا روابط بهتری برقرار کنید و از برخوردهای ناخواسته
          جلوگیری کنید. برای مثال، در یک بحث کاری، اگر به احساسات طرف مقابل توجه
          کنید و از گفتارهایی که ممکن است آن‌ها را آزرده خاطر کند خودداری کنید،
          نتیجه بهتری خواهید گرفت.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>5. توقف دوره‌ای و بازنگری عمیق در کارها :</strong> گاهی اوقات
          لازم است که برای ارزیابی پیشرفت خود، یک توقف دوره‌ای داشته باشید و
          کارها را دوباره بررسی کنید. این روش به شما این امکان را می‌دهد که نقاط
          ضعف خود را شناسایی کرده و به آن‌ها توجه بیشتری کنید. برای مثال، پس از
          اتمام یک پروژه بزرگ، ممکن است یک جلسه بازخورد برگزار کنید تا عملکرد
          خود و تیم را ارزیابی کرده و مسیر بهبود را شناسایی کنید.
        </p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7">
          <strong>6. عمیق شدن :</strong> عمیق شدن در مسائل مختلف، به ویژه در
          تحلیل مسائل کاری و شخصی، یکی از ویژگی‌های افراد موفق است. وقتی به سطح
          عمیق‌تری از موضوعات نگاه کنید، می‌توانید راه‌حل‌های بهتری پیدا کنید و
          از نتیجه‌گیری‌های سطحی پرهیز کنید. برای مثال، در ارزیابی یک پروژه یا
          یک فرصت جدید، بررسی جزئیات و دست‌یابی به اطلاعات دقیق‌تر می‌تواند به
          شما کمک کند که تصمیمات بهتری بگیرید.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>7. توسعه ارتباطات اجتماعی :</strong> شبکه‌سازی و ایجاد
          ارتباطات اجتماعی می‌تواند به شما در رشد حرفه‌ای و شخصی کمک کند. از این
          رو، توصیه می‌شود که وقت بگذارید و روابط خود را با دیگران گسترش دهید.
          این امر می‌تواند در محیط‌های کاری، اجتماعی و حتی خانوادگی بسیار
          تاثیرگذار باشد. برای مثال، حضور در کنفرانس‌ها، کارگاه‌های آموزشی، یا
          حتی ملاقات‌های غیررسمی می‌تواند فرصت‌های جدیدی را برای شما به همراه
          داشته باشد.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>8. متعهد بودن :</strong> تعهد به اهداف و مسئولیت‌ها یکی از
          ارکان موفقیت است. زمانی که شما به چیزی متعهد می‌شوید، قدرت و تمرکز
          بیشتری برای رسیدن به هدف خواهید داشت. برای مثال، اگر تعهد به تکمیل یک
          پروژه خاص را دارید، باید از تمامی منابع و توان خود برای رسیدن به آن
          استفاده کنید. این تعهد باعث می‌شود تا هم در مسیر موفقیت ثابت قدم
          بمانید و هم اعتبار خود را در بین همکاران و دوستان حفظ کنید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت لایه‌های S ، C و I برای افراد با الگوی   High D"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی High D معمولاً مستقل، قوی، و دارای اعتماد به نفس بالا
          هستند. این ویژگی‌ها ممکن است باعث شود که در تعاملات اجتماعی و تیمی، به
          ویژه در موقعیت‌های حساس یا پیچیده، کمی به سمت رفتارهای سریع، بی‌توجه
          به جزئیات یا عدم همدلی حرکت کنند. برای تعدیل و تقویت لایه‌های S ، C و
          I برای این افراد، توصیه‌هایی مبتنی بر مدارا، شیوایی کلام، همدلی و
          ویژگی‌های انسانی و حرفه‌ای آورده شده است:
        </p>

        <p className="text-gray-800 leading-7">
          <strong>1. تعدیل لایه S صبور بودن و همدلی :</strong> افراد با الگوی
          High D اغلب تمایل دارند که سریع و قاطع عمل کنند و ممکن است در این روند
          کمتر به احساسات دیگران توجه کنند. در این شرایط، مدارا و همدلی از اهمیت
          بالایی برخوردارند. توصیه می‌شود که افراد با این الگو یاد بگیرند که
          صبورتر و آرام‌تر باشند و به دیگران اجازه دهند تا نظرات خود را بیان
          کنند. شیوایی کلام و برقراری صمیمیت در ارتباطات می‌تواند تاثیر زیادی
          داشته باشد. افراد باید یاد بگیرند که در تیم‌های کاری، حمایت از دیگران
          و ایجاد فضایی برای شادی و صمیمیت، به شدت می‌تواند روابط را تقویت کند.
          برای بهبود لایه S، توجه به جزئیات مهم و بررسی دوباره کارها می‌تواند
          مفید باشد. باید لذت بردن از داشته‌ها هنر است و در کنار این لذت، باید
          بدانیم که ما نیازمند جزئیات و تحلیل‌های عمیق‌تر هستیم. به این ترتیب،
          به دیگران فضای بیشتری برای رشد و ایجاد تعادل در روند کاری داده می‌شود
          و آن‌ها احساس حمایت و همدلی بیشتری خواهند داشت.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>2. تعدیل لایه C دقت و تحلیل دقیق‌تر :</strong> افرادی با High
          D ممکن است به سرعت تصمیم بگیرند و به جزئیات اهمیت زیادی ندهند. برای
          تقویت لایه C ، توصیه می‌شود که افراد یاد بگیرند که بررسی مجدد کارها
          خیلی مهم است و باید بیشتر در دقت و تحلیل کارها عمیق شوند. عمیق‌تر شدن
          در کارها رمز موفقیت است. فرد باید با انعطاف‌پذیری بیشتری به بررسی
          جزئیات پرداخته و با صبور بودن از تحلیل‌های دقیق‌تری استفاده کند. در
          مسیرهای کاری، ما نیازمند هستیم مسیر رسیدن به نتیجه را دوباره چک کنیم و
          مشکلات و موانع پیش رو را دقیق شناسایی کنیم. در واقع، برای رسیدن به
          موفقیت بلندمدت، مطابق با یک نقشه و چارچوب عمل کردن رمز موفقیت است. این
          تمرین‌ها کمک می‌کند تا فرد با قدرت بیشتر و دقت بالاتر تصمیم‌گیری کند و
          همزمان، از اشتباهات احتمالی جلوگیری نماید.
        </p>
      </Page>

      <Page testResult={testResult}>
        <p className="text-gray-800 leading-7">
          <strong>3. تعدیل لایه I ارتباطات اجتماعی و انگیزش :</strong> افراد با
          الگوی High D به طور معمول تمایل دارند که بر روی تصمیمات خود تمرکز کرده
          و ممکن است در برخی مواقع از ارتباطات اجتماعی یا کارتیمی غافل شوند.
          برای تقویت این لایه، همدلی و شادی در محیط کار می‌تواند فضای مثبت و
          انگیزشی ایجاد کند. افراد با High D می‌توانند از ابزارهای شیوایی کلام و
          صمیمیت برای برقراری ارتباطات عمیق‌تر با همکاران و اعضای تیم استفاده
          کنند. ایجاد صلح و دوستی و حمایت از دیگران، به رشد تیم کمک کرده و
          انگیزه افراد را افزایش می‌دهد. همچنین باید به خاطر داشت که در تیم‌ها،
          ما نیازمند جزئیات و تحلیل‌های عمیق‌تر هستیم تا عملکردهای فردی و جمعی
          به بهترین نحو پیش برود. علاوه بر این، توجه به لذت بردن از داشته‌ها هنر
          است، چرا که این رویکرد کمک می‌کند تا افراد در روند کاری از لحظات خود
          لذت ببرند و احساس رضایت کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title={
          "دانش و مهارت های مورد نیاز جهت بهبود عملکرد افراد با الگوی High D"
        }
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی High D معمولاً افراد قوی، مصمم و با اعتماد به نفس
          بالایی هستند، اما ممکن است در تعاملات اجتماعی و درک نیازهای دیگران
          دچار چالش شوند. برای بهبود عملکرد این افراد، توسعه مجموعه‌ای از
          مهارت‌ها و دانش‌ها می‌تواند به آن‌ها کمک کند تا در محیط کاری و زندگی
          شخصی خود موفق‌تر عمل کنند. در ادامه، لیستی از مهارت‌ها و دانش‌های
          کلیدی آورده شده است:
        </p>

        <p className="text-gray-800 leading-7">
          <strong>1. کارتیمی :</strong> افراد با الگوی High D ممکن است به راحتی
          تمایل به رهبری و هدایت داشته باشند و از کارهای گروهی دوری کنند. برای
          تقویت این مهارت، آموزش‌هایی در زمینه کار تیمی و همکاری موثر با دیگران
          لازم است. افراد باید یاد بگیرند که پذیرش نظر دیگران و تبادل ایده‌ها
          می‌تواند به بهبود کار تیمی کمک کند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>2. همدلی و سازگاری :</strong> آموزش مهارت‌های همدلی به افراد
          کمک می‌کند تا بتوانند احساسات و نیازهای دیگران را درک کرده و در
          تعاملات اجتماعی موفق‌تر باشند. سازگاری با شرایط مختلف و پذیرش تنوع در
          افکار و رفتارهای دیگران به بهبود روابط کاری و اجتماعی کمک می‌کند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>3. مثبت‌اندیشی :</strong>
          یکی از مهارت‌های کلیدی برای افراد با الگوی High D ، مثبت‌اندیشی است.
          افراد باید یاد بگیرند که در مواجهه با چالش‌ها و فشارها، نگاه مثبت خود
          را حفظ کنند و راه‌حل‌های خلاقانه برای مشکلات بیابند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>4. مهارت‌های کار و زندگی :</strong> تقویت مهارت‌های مدیریت
          زمان، اولویت‌بندی کارها، و تصمیم‌گیری موثر می‌تواند کمک زیادی به افراد
          با High D بکند. همچنین، مهارت‌های حل مسئله و انگیزش درونی باید در این
          افراد تقویت شود تا در موقعیت‌های مختلف بهتر عمل کنند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>5. ترسیم نقشه راه موفقیت همراه با جزئیات :</strong> افراد باید
          یاد بگیرند که موفقیت را در قالب یک نقشه راه مشخص ترسیم کنند. این نقشه
          باید شامل اهداف بلندمدت و کوتاه‌مدت، اولویت‌ها، و جزئیات اجرایی باشد
          تا به آن‌ها کمک کند تا بر روی اهداف خود متمرکز باقی بمانند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>6. ارتباطات موثر :</strong> برای تقویت ارتباطات، افراد باید
          مهارت‌های گوش دادن فعال و برقراری ارتباط شفاف و موثر را بیاموزند. این
          مهارت‌ها به آن‌ها کمک می‌کند تا به راحتی با دیگران تعامل کنند و نیازها
          و خواسته‌های خود را به درستی بیان کنند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>7. مدیریت خشم :</strong> مدیریت خشم و کنترل احساسات در
          موقعیت‌های فشارزا از دیگر مهارت‌های کلیدی برای افراد با الگوی High D
          است. آموزش‌هایی در زمینه کنترل احساسات، تنفس عمیق، و استفاده از
          تکنیک‌های آرام‌سازی می‌تواند به آن‌ها کمک کند.
        </p>
      </Page>

      <Page testResult={testResult}>
        <p className="text-gray-800 leading-7">
          <strong>8. رقابت در عین همکاری :</strong> افراد با High D معمولاً
          رقابتی هستند. آموزش این مهارت که چگونه می‌توانند در عین رقابت با
          دیگران، روحیه همکاری را حفظ کنند، بسیار مهم است. رقابت سالم و ایجاد
          فضایی که در آن همگان برنده باشند می‌تواند به افزایش کارایی و انگیزه در
          تیم‌های کاری کمک کند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>9. اخلاق حرفه‌ای :</strong> افراد با الگوی High D باید تمرکز
          بیشتری بر روی اخلاق حرفه‌ای و رعایت اصول اخلاقی در محیط کار داشته
          باشند. این شامل احترام به دیگران، صداقت، و پایبندی به تعهدات می‌شود.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>10. انعطاف‌پذیری :</strong> انعطاف‌پذیری یکی از مهارت‌های مهم
          برای افرادی با الگوی High D است. یادگیری اینکه چگونه در برابر تغییرات
          و شرایط جدید انعطاف‌پذیر و سازگار باشند، می‌تواند به آن‌ها کمک کند تا
          در محیط‌های کاری پرچالش و پویا بهتر عمل کنند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>11. خوب گوش کردن :</strong> گوش دادن فعال به دیگران مهارتی است
          که می‌تواند در بهبود روابط اجتماعی و کاری نقش مهمی ایفا کند. افراد با
          High D باید تمرکز بیشتری روی گوش دادن به دیگران و فهمیدن دیدگاه‌های
          مختلف داشته باشند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>12. عمیق شدن در جزئیات :</strong> افراد با High D معمولاً
          تمایل دارند که به سرعت تصمیم بگیرند و تمرکز زیادی روی جزئیات ندارند.
          آموزش مهارت‌های دقت و توجه به جزئیات می‌تواند به تقویت عملکرد آن‌ها در
          محیط‌های کاری نیازمند دقت و تحلیل عمیق کمک کند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>13. شفاف کردن خواسته‌ها و دلیل آن :</strong> برای داشتن
          ارتباطات موثر، افراد باید توانایی شفاف کردن خواسته‌ها و دلیل آن را
          داشته باشند تا درک بهتری از اهداف و انتظارات خود ارائه دهند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>14. نحوه بروز احساسات :</strong> افراد با High D باید
          مهارت‌های بروز احساسات را بیاموزند. این شامل توانایی بیان نظرات،
          احساسات، و خواسته‌ها به شیوه‌ای صادقانه و مؤثر است که منجر به ایجاد
          ارتباطات مثبت و صمیمی‌تر با دیگران می‌شود.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>15. هوش هیجانی :</strong>
          تقویت هوش هیجانی می‌تواند به افراد کمک کند تا در مواجهه با چالش‌های
          احساسی بهتر عمل کنند. این شامل خودآگاهی، خودتنظیمی، همدلی، و مهارت‌های
          اجتماعی می‌شود.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>16. سخنرانی اثربخش :</strong> افراد High D باید مهارت‌های
          سخنرانی اثربخش را بیاموزند تا بتوانند پیام خود را به صورت روشن و
          قانع‌کننده به دیگران منتقل کنند. این مهارت شامل اعتماد به نفس و ارتباط
          غیرکلامی است.
        </p>
      </Page>

      <Page testResult={testResult}>
        <p className="text-gray-800 leading-7">
          <strong>17. توسعه مهارت‌های اجتماعی :</strong> تقویت مهارت‌های اجتماعی
          می‌تواند به افراد کمک کند تا روابط بهتری در محیط‌های کاری و شخصی
          برقرار کنند. این مهارت‌ها شامل ارتباطات مؤثر، همدلی، و حل اختلافات
          است.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>18. برند سازی شخصی :</strong> برند سازی شخصی به افراد کمک
          می‌کند تا هویت حرفه‌ای خود را مشخص کرده و در مسیر رشد و موفقیت، تصویر
          مثبتی از خود ایجاد کنند.
        </p>

        <p className="text-gray-800 leading-7">
          <strong>19. توسعه مهارت‌های تمرکز :</strong>
          تقویت مهارت‌های تمرکز برای افراد با High D ضروری است تا بتوانند بر روی
          جزئیات مهم تمرکز کرده و از تصمیمات شتابزده جلوگیری کنند. این مهارت‌ها
          به آن‌ها کمک می‌کند تا در محیط‌های پیچیده و پرتنش عملکرد بهتری داشته
          باشند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title={"مشاغل مناسب برای افراد با الگوی High D"}
      >
        <p className="text-gray-800 leading-7">
          افرادی که الگوی رفتاری High D دارند، معمولاً شخصیت‌های پرانرژی، مصمم و
          شجاع با تمایل به تصمیم‌گیری سریع و حل مسائل پیچیده هستند. این افراد
          معمولاً به مشاغلی نیاز دارند که آزادی عمل، استقلال در تصمیم‌گیری و
          چالش‌های عملیاتی و اجرایی در آن‌ها وجود داشته باشد. مشاغلی که نیاز به
          تحلیل، تصمیم‌گیری سریع و حل مسأله دارند، برای آن‌ها مناسب‌تر هستند. با
          توجه به این ویژگی‌ها، در ادامه فهرستی از مشاغل مناسب برای افراد با
          الگوی High D آمده است:
        </p>

        <p className="text-gray-800 leading-7">
          1. مهندس مکانیک طراحی و تحلیل سیستم‌های مکانیکی، حل مسائل مهندسی، و
          نیاز به تصمیم‌گیری سریع و مستقل برای حل مشکلات. 2. مکانیک هواپیما
          تعمیر و نگهداری سیستم‌های پیچیده هواپیماها، نیاز به دقت، حل مسأله و
          تصمیم‌گیری سریع در موقعیت‌های حساس. 3. کارشناس توسعه کسب و کار تحلیل
          فرصت‌های بازار، طراحی استراتژی‌های رشد، و تعامل با تیم‌های مختلف برای
          دستیابی به اهداف توسعه. 4. طراح بازی‌های کسب و کار ایجاد و طراحی
          استراتژی‌های کسب و کار برای بازی‌های دیجیتال یا کسب و کارهای مبتنی بر
          رقابت، چالش و نوآوری. 5. آژانس املاک مشاوره و مدیریت خرید و فروش
          املاک، نیاز به استقلال، توانایی مذاکره و حل مسائل مرتبط با بازار
          املاک. 6. مدیر نهادهای سرمایه‌گذاری مدیریت و تحلیل سرمایه‌گذاری‌ها،
          نیاز به تصمیم‌گیری سریع و تحلیل بازارهای مالی برای بهینه‌سازی سود. 7.
          مدیر امور شهری برنامه‌ریزی و مدیریت پروژه‌های بزرگ شهری، تصمیم‌گیری
          استراتژیک برای توسعه زیرساخت‌ها و خدمات عمومی. 8. مدیر تولید مدیریت
          فرآیندهای تولید، بهینه‌سازی بهره‌وری و حل مسائل اجرایی در راستای تحقق
          اهداف تولیدی. 9. مدیرعامل رهبری و هدایت یک سازمان به سوی اهداف
          بلندمدت، تصمیم‌گیری استراتژیک و حل مسائل پیچیده سازمانی. 7. مدیر امور
          شهری برنامه‌ریزی و مدیریت پروژه‌های بزرگ شهری، تصمیم‌گیری استراتژیک
          برای توسعه زیرساخت‌ها و خدمات عمومی. 8. مدیر تولید مدیریت فرآیندهای
          تولید، بهینه‌سازی بهره‌وری و حل مسائل اجرایی در راستای تحقق اهداف
          تولیدی. 9. مدیرعامل رهبری و هدایت یک سازمان به سوی اهداف بلندمدت،
          تصمیم‌گیری استراتژیک و حل مسائل پیچیده سازمانی. 10. مدیر دارایی و
          اموال مدیریت دارایی‌ها و اموال سازمان، نیاز به تحلیل دقیق و تصمیم‌گیری
          در مورد سرمایه‌گذاری و منابع مالی. 11. مهندس عمران طراحی، ساخت و نظارت
          بر پروژه‌های عمرانی و زیرساختی، نیاز به تصمیم‌گیری در مواقع بحرانی و
          حل مسائل پیچیده. 12. مدیر ارزیابی توسعه کسب و کار تحلیل و ارزیابی
          عملکرد کسب و کار، شناسایی فرصت‌های رشد و تصمیم‌گیری در مورد توسعه
          استراتژی‌های جدید.
        </p>
      </Page>

      <Page testResult={testResult}>
        <p className="text-gray-800 leading-7">
          13. متخصص فوریت‌های پزشکی واکنش سریع به شرایط اضطراری و نیاز به
          تصمیم‌گیری فوری در مواقع بحرانی. 14. فیزیولوژیست ورزشی تحلیل و ارزیابی
          عملکرد فیزیکی ورزشکاران، نیاز به تحلیل دقیق و بهینه‌سازی عملکرد. 15.
          مدرس پرواز آموزش و هدایت خلبانان، نیاز به دقت، تصمیم‌گیری سریع و نظارت
          بر عملکردهای اجرایی. 16. معامله‌گر بورس اوراق بهادار خرید و فروش سهام،
          تحلیل بازار و تصمیم‌گیری سریع در مورد خرید و فروش دارایی‌های مالی. 17.
          سرمایه‌گذار شناسایی فرصت‌های سرمایه‌گذاری و تصمیم‌گیری در مورد بهترین
          استراتژی‌های مالی. 18. مهندس الکترونیک طراحی و تحلیل سیستم‌های
          الکترونیکی و نیاز به حل مسائل فنی پیچیده. 19. پلیس نیروی انتظامی تأمین
          امنیت عمومی و واکنش به موقع در شرایط اضطراری. 20. آتش‌نشان مقابله با
          حوادث آتش‌سوزی، نیاز به تصمیم‌گیری سریع و عمل تحت فشار. 21. کارآگاه
          تحقیق و جمع‌آوری اطلاعات برای حل پرونده‌های پیچیده، نیاز به تصمیم‌گیری
          سریع و تحلیل دقیق اطلاعات. 22. خلبان هواپیما هدایت و کنترل هواپیما،
          نیاز به توانایی تصمیم‌گیری سریع در شرایط بحرانی. 23. ناخدای کشتی هدایت
          کشتی‌ها در دریا، نیاز به نظارت دقیق و تصمیم‌گیری در شرایط مختلف محیطی.
          24. صادر کننده مجوز پرواز، کنترل‌کننده ترافیک هوایی نظارت و هماهنگی
          پروازها، نیاز به دقت و توانایی تصمیم‌گیری سریع برای حفظ ایمنی. 25.
          بازرس راه و ساختمان ارزیابی ساختارهای ساختمانی و شناسایی مشکلات موجود،
          نیاز به تصمیم‌گیری سریع و دقت در ارزیابی. 26. تکنسین رادیولوژی کار با
          تجهیزات پزشکی برای انجام آزمایشات تصویربرداری، نیاز به دقت و توانایی
          حل مشکلات فنی.
        </p>
      </Page>

      <Page testResult={testResult} title="نکات کلیدی برای انتخاب شغل">
        <p className="text-gray-800 leading-7">
          افراد با الگوی High D به مشاغلی علاقه‌مند هستند که در آن‌ها آزادی عمل،
          استقلال در تصمیم‌گیری، و چالش‌های عملیاتی و اجرایی وجود داشته باشد.
          این افراد به مشاغلی علاقه دارند که در آن‌ها بتوانند مسائل پیچیده را حل
          کنند و درگیر تحلیل و تصمیم‌گیری باشند. مشاغلی که شامل رقابت، فشار
          زمان، و کار در محیط‌های پرفشار باشند، می‌توانند برای این افراد جذاب
          باشند. همچنین، افراد با این الگو به دنبال مشاغلی هستند که پرستیژ
          اجتماعی و درآمد بالا داشته باشند و بتوانند در آن‌ها نقش رهبری ایفا
          کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="همسر مناسب برای افراد با الگوی High D و نحوه ارتباط مؤثر با او"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری High D ، معمولاً شخصیت‌هایی قاطع، مستقل،
          پرانرژی، هدف‌محور و دارای تمایل به تسلط و تصمیم‌گیری سریع هستند. این
          ویژگی‌ها بر روابط زناشویی آن‌ها نیز تأثیر مستقیم می‌گذارد. بنابراین
          شناخت ویژگی‌های مناسب برای همسر آن‌ها و نحوه تعامل صحیح، می‌تواند به
          داشتن یک رابطه پایدار و رضایت‌بخش کمک کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های مناسب برای همسر یک فرد High D"
      >
        <p className="text-gray-800 leading-7">
          1. صبور و آرام، بدون روحیه مقابله‌جویانه فرد High D از بحث‌های فرسایشی
          یا لجبازی متنفر است. همسری که بتواند آرام بماند و از برخورد مستقیم در
          هنگام عصبانیت اجتناب کند، بهتر با این الگو کنار می‌آید. مثال: در یک
          مشاجره، همسر یک High D نباید با لحن تند مقابله کند، بلکه می‌تواند
          بگوید: "می‌فهمم که عصبانی هستی، بذار وقتی آروم شدی با هم صحبت کنیم."
        </p>

        <p className="text-gray-800 leading-7">
          2. اعتماد به نفس کافی فرد High D معمولاً از همسری ضعیف و بدون استقلال
          بیزار است. او به کسی احترام می‌گذارد که عزت‌نفس بالا و قدرت تصمیم‌گیری
          خودش را دارد.
        </p>

        <p className="text-gray-800 leading-7">
          3. توانایی حمایت در پشت صحنه چون High D دوست دارد در مرکز قدرت باشد،
          همسرش باید توانایی حمایت از او بدون ایجاد حس رقابت یا کنترل را داشته
          باشد. مثال: اگر High D تصمیم مهمی درباره خرید خانه گرفته، همسرش بهتر
          است ابتدا حمایت را نشان دهد و سپس با احترام و دلیل، نکاتی برای بررسی
          بیشتر مطرح کند.
        </p>

        <p className="text-gray-800 leading-7">
          4. توان مدیریت احساسات افراد High D ممکن است در بیان احساسات ضعیف
          باشند. همسر آن‌ها باید بتواند نیازهای عاطفی خود را به‌درستی و بدون
          توقع مستقیم مطرح کند. مثال: به جای اینکه بگوید "تو اصلاً به من توجه
          نمی‌کنی!"، بگوید: "خیلی دوست دارم گاهی بیشتر با هم وقت بگذرونیم. برام
          مهمه."
        </p>

        <p className="text-gray-800 leading-7">
          4. توان مدیریت احساسات افراد High D ممکن است در بیان احساسات ضعیف
          باشند. همسر آن‌ها باید بتواند نیازهای عاطفی خود را به‌درستی و بدون
          توقع مستقیم مطرح کند. مثال: به جای اینکه بگوید "تو اصلاً به من توجه
          نمی‌کنی!"، بگوید: "خیلی دوست دارم گاهی بیشتر با هم وقت بگذرونیم. برام
          مهمه."
        </p>
      </Page>

      <Page testResult={testResult} title="نکاتی که همسر فرد High D باید بداند">
        <p className="text-gray-800 leading-7">
          1. نباید به او دستور داد. جمله‌های دستوری مثل "باید این کار رو انجام
          بدی!" ممکن است باعث مقابله یا واکنش تند شود. بهتر است از جملات
          پیشنهادی با اختیار استفاده شود. جایگزین: "فکر می‌کنی خوبه که فلان کار
          رو الان انجام بدیم؟"
        </p>

        <p className="text-gray-800 leading-7">
          2. او را بابت نتایجش تحسین کنید. High D به نتیجه اهمیت می‌دهد، پس
          تحسین عملکرد و نتیجه‌های ملموس او تأثیرگذارتر از تعریف‌های کلی است.
          مثال: "واقعاً تحسین‌برانگیزه که چقدر سریع تونستی اون پروژه رو به
          سرانجام برسونی."
        </p>

        <p className="text-gray-800 leading-7">
          3. بر سر مسائل جزئی جر و بحث نکنید. او حوصله بحث‌های جزئی را ندارد.
          اگر موضوع خیلی مهم نیست، بهتر است از آن بگذرید یا در زمان مناسب‌تری
          مطرح شود.
        </p>

        <p className="text-gray-800 leading-7">
          4. زمانی برای آرام‌سازی به او بدهید. وقتی عصبانی یا خسته است، فوراً
          وارد بحث نشوید. به او اجازه دهید ابتدا آرام شود. 5. برنامه‌محوری او را
          بپذیرید. بسیاری از High D ها زمان، هدف و چارچوب دارند. همسر باید
          انعطاف لازم را برای هم‌راستایی با اهداف و برنامه‌های او داشته باشد یا
          برنامه‌های خود را به‌صورت منطقی مطرح کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که فرد High D باید در زندگی زناشویی رعایت کند"
      >
        <p className="text-gray-800 leading-7">
          گوش دادن فعال را تمرین کند. همیشه به دنبال پاسخ دادن نباشد، بلکه گاهی
          فقط گوش دهد. در ابراز احساسات تمرین کند. گفتن جملاتی مانند "از اینکه
          کنارمی خوشحالم" می‌تواند در رابطه معجزه کند. به استقلال همسر احترام
          بگذارد. کنترل‌گری زیاد می‌تواند باعث دلسردی همسر شود. انتقادپذیر باشد.
          همه‌چیز را مسابقه یا تهدید نبیند. گاهی پذیرش یک انتقاد سازنده، رابطه
          را عمیق‌تر می‌کند.
        </p>
      </Page>

      <Page testResult={testResult} title="جمع‌بندی">
        <p className="text-gray-800 leading-7">
          رابطه زناشویی با فرد High D می‌تواند پرانرژی، نتیجه‌محور، و در عین حال
          پُرچالش باشد. اما با شناخت دقیق شخصیت و ایجاد فضای احترام و درک
          متقابل، می‌توان یکی از پایدارترین و موفق‌ترین روابط را شکل داد. مهم
          این است که قدرت، عشق و درک همزمان در رابطه حفظ شوند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین High D با فرزندان و بالعکس"
      >
        <p className="text-gray-800 leading-7">
          افرادی با الگوی رفتاری High D ، معمولاً والدینی قاطع، نتیجه‌محور،
          سریع‌العمل و با توقعات بالا هستند. آن‌ها می‌خواهند فرزندانشان مستقل،
          موفق، و اهل عمل باشند. اما اگر مراقب نباشند، این ویژگی‌ها ممکن است
          منجر به فشار روانی، کاهش صمیمیت، و فاصله عاطفی با فرزندان شود. این
          سرفصل، راهکارهایی برای بهبود تعامل میان والدین High D و فرزندان ارائه
          می‌دهد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="والدین High D چگونه با فرزندان خود ارتباط مؤثر برقرار کنند؟"
      >
        <p className="text-gray-800 leading-7">
          1. صمیمیت و آرامش را در اولویت قرار دهند. فرزندان برای رشد روانی سالم،
          نیاز به مهر، حمایت و امنیت عاطفی دارند، نه فقط عملکرد بالا. مثال: در
          کنار تأکید بر نمره، بگویید: "مهم‌تر از نمره، اینه که تلاش کردی و یاد
          گرفتی. من بهت افتخار می‌کنم."
        </p>

        <p className="text-gray-800 leading-7">
          2. مدارا با احساسات فرزند را یاد بگیرند. High D ها تمایل دارند احساسات
          را نادیده بگیرند، اما باید بدانند که درک و همدلی با دنیای عاطفی کودک،
          سرمایه‌گذاری بلندمدت است. جمله پیشنهادی: "می‌فهمم ناراحتی، دوست دارم
          در موردش با هم حرف بزنیم."
        </p>

        <p className="text-gray-800 leading-7">
          3. کاهش دستوری صحبت کردن، افزایش گفت‌وگو و مشارکت. به جای «باید این
          کار رو انجام بدی»، بهتر است از جملات مشارکتی استفاده شود: "دوست دارم
          نظرت رو بدونم، به نظرت این راه بهتره یا اون یکی؟"
        </p>

        <p className="text-gray-800 leading-7">
          4. تشویق به شادی، بازی و لذت بردن از داشته‌ها. والدین High D باید توجه
          کنند که کودکی، محل لذت، شادی، صلح و دوستی است، نه فقط پیشرفت. یادآوری
          مهم: "لذت بردن از داشته‌ها هنر است."
        </p>

        <p className="text-gray-800 leading-7">
          5. ایجاد چارچوب همراه با انعطاف‌پذیری. مطابق با یک نقشه و چارچوب عمل
          کردن رمز موفقیت است، اما باید متناسب با سن و روحیات فرزند باشد.
        </p>

        <p className="text-gray-800 leading-7">
          6. پذیرش اشتباهات کودک با صبوری و حمایت. فرزند باید احساس کند در برابر
          اشتباه، مورد قضاوت شدید یا طرد قرار نمی‌گیرد.
        </p>

        <p className="text-gray-800 leading-7">
          7. تمرین مهارت خوب گوش کردن و همدلی.
        </p>

        <p className="text-gray-800 leading-7">
          خوب گوش کردن، صمیمیت را تقویت می‌کند و جلوی فاصله عاطفی را می‌گیرد.
        </p>
      </Page>

      <Page testResult={testResult} title="جمع‌بندی">
        <p className="text-gray-800 leading-7">
          برای یک رابطه سالم والد-فرزندی در الگوی High D ، باید تعادل برقرار شود
          میان اقتدار و حمایت، سرعت و صبر، هدف‌مندی و شادی، پیشرفت و لذت بردن از
          داشته‌ها. والدین باید یاد بگیرند همدل، صبور، و شنوا باشند و فرزندان
          باید احترام، گفت‌وگو و کنترل خشم را تمرین کنند. ارتباط مؤثر بین آن‌ها،
          بنیان یک زندگی آرام و موفق خواهد بود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چگونه با والد High D ارتباط مؤثر برقرار کنیم؟"
      >
        <p className="text-gray-800 leading-7">
          1. احترام به اقتدار و چارچوب پدر/مادر والد High D معمولاً اقتدار،
          قاطعیت و ساختار را مهم می‌داند. فرزند باید یاد بگیرد که در صحبت با او،
          حد و مرزها را رعایت کند و از لحن طلبکارانه یا مقابله‌ای پرهیز کند.
          مثال: به‌جای گفتن "تو همیشه به من زور می‌گی!" بهتر است گفته شود:
          "می‌تونیم راجع به این موضوع یه کم بیشتر با هم حرف بزنیم؟ برام مهمه نظر
          شما رو بدونم."
        </p>

        <p className="text-gray-800 leading-7">
          2. ارائه دلیل و منطق در خواسته‌ها: والدین High D با منطق و دلیل قانع
          می‌شوند، نه با احساسات صرف. اگر خواسته‌ای دارید، دلیل آن را بگویید.
          مثال: "اگه اجازه بدید کلاس فوتبال برم، می‌تونم انرژیم رو توی ورزش
          تخلیه کنم و تمرکز بهتری روی درسم داشته باشم."
        </p>

        <p className="text-gray-800 leading-7">
          3. کمک به والد در رسیدن به هدف والد High D عاشق نتیجه‌گیری، پیشرفت و
          پیروزی است. اگر فرزند بتواند در مسیر اهداف خانوادگی یا شخصی او نقش
          فعال ایفا کند، احساس غرور و رضایت زیادی در والد ایجاد می‌شود. مثال:
          "بابا می‌خوای امروز توی برنامه‌ریزی خرید خونگی کمکت کنم که سریع‌تر
          انجام بشه؟"
        </p>

        <p className="text-gray-800 leading-7">
          4. حفظ آرامش و جلوگیری از تحریک خشم والد والدین High D ممکن است زود
          عصبانی شوند، اما اگر ببینند که فرزندشان آرام، دقیق و محترمانه رفتار
          می‌کند، زود آرام می‌گیرند. یادآوری مهم: "صلح و دوستی در خانواده،
          نتیجه‌ی صبوری و احترام دوطرفه است."
        </p>

        <p className="text-gray-800 leading-7">
          5. ابراز صمیمیت و قدردانی با شیوایی کلام اگرچه والد High D ممکن است
          خیلی عاطفی نباشد، اما تأثیرپذیر است از بیان مستقیم محبت و تشکر. مثال:
          "بابا واقعاً ممنونم که امروز برام وقت گذاشتی، خوشحال شدم."
        </p>

        <p className="text-gray-800 leading-7">
          6. رعایت نظم و جدی گرفتن مسئولیت‌ها پدر یا مادر High D از بی‌نظمی،
          بی‌برنامگی یا وقت‌کشی ناراحت می‌شود. فرزند باید یاد بگیرد طبق نقشه و
          چارچوب عمل کند. یادآوری مهم: "مطابق با یک نقشه و چارچوب عمل کردن، رمز
          موفقیت است."
        </p>

        <p className="text-gray-800 leading-7">
          7. گوش دادن فعال و نشان دادن علاقه به حرف‌های او حتی اگر پدر/مادر
          کم‌حرف است، وقتی صحبت می‌کند باید با علاقه گوش داد. این باعث افزایش
          صمیمیت و اعتماد می‌شود. جمله پیشنهادی: "میشه بیشتر در مورد تجربه
          کاری‌تون برام بگید؟ همیشه برام جالبه بدونم چطور به اینجا رسیدین."
        </p>

        <p className="text-gray-800 leading-7">
          8. مشارکت در کارتیمی خانوادگی والدین High D معمولاً دوست دارند مدیریت
          کنند، اما از همکاری واقعی فرزندان استقبال می‌کنند. مثال: در پروژه‌های
          خانوادگی یا حتی برنامه‌ریزی مسافرت، با او مشارکت کنید و بگویید:
          "می‌خوای برنامه‌ سفر رو با هم بچینیم؟ فکر کنم ایده‌هام به دردت بخوره."
        </p>
      </Page>

      <Page testResult={testResult} title="جمع‌بندی">
        <p className="text-gray-800 leading-7">
          فرزندان یک والد High D باید یاد بگیرند که با احترام، منطق، صبوری،
          همدلی و مشارکت واقعی وارد رابطه شوند. درک اینکه این والد بیشتر
          هدف‌محور است تا احساس‌محور، به آن‌ها کمک می‌کند تا موانع ارتباطی را به
          فرصت‌های صمیمیت تبدیل کنند. آن‌ها باید هنر «لذت بردن از داشته‌ها» را
          به والد خود یادآوری کنند و در عین حال، خود نیز از جزئیات، گفت‌وگو و
          آرامش غافل نشوند.``
        </p>
      </Page>
    </>
  );
};

export default HighD;
